import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchDashboardStatistics } from "../../redux/slices/dashboardSlice";
import Stats from "../../components/Dashboard/Stats";
import AppUsers from "../../components/Dashboard/AppUsers";
import Bids from "../../components/Dashboard/Bids";
import AuctionStatistics from "../../components/Dashboard/AuctionStatistics";
import Auctions from "../../components/Dashboard/Auctions";

function Dashboard() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Fetch dashboard statistics for current year
    const currentYear = new Date().getFullYear();
    dispatch(fetchDashboardStatistics({
      from: `${currentYear}-01-01T00:00:00.000Z`,
      to: `${currentYear}-12-31T23:59:59.999Z`
    }));
  }, [dispatch]);

  return (
    <div>
      <div className="">
        <Stats />
      </div>
      <div className="mt-3"></div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div>
          <AppUsers />
        </div>
        <div>
            <Bids />
        </div>
        <div>
            <AuctionStatistics />
        </div>
      </div>
      <div className="mt-3"></div>
      <div className="">
          <Auctions />
      </div>
    </div>
  );
}

export default Dashboard;
